import Icon from '@ant-design/icons';

import { ReactComponent as ChangePasswordIcon } from './svgs/change-password.svg';

const ChangePassword = props => {
  return <Icon component={ChangePasswordIcon} {...props} />;
};

export default ChangePassword;
